import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import Breadcrumb from '../components/common/Breadcrumb';
import Image from '../components/common/Image';
import Price from '../components/product/Price';
import { useCart } from '../context/CartContext';
import { IconTrash } from '../components/common/Icons';

export default function Wishlist() {
  const { wishlist, toggleWish } = useCart();
  return (
    <>
      <Seo title="Wishlist" noIndex />
      <div className="page-header py-8 md:py-12 text-center"><div className="container-fluid"><h1 className="page-header__title text-3xl md:text-4xl">Wishlist</h1></div></div>
      <Breadcrumb items={[{ label: 'Wishlist' }]} />
      <div className="container-fluid section-my">
        {wishlist.length === 0 ? (
          <div className="text-center py-16"><p className="text-lg text-color-secondary mb-6">Your wishlist is empty.</p><Link to="/collections/all" className="sf__btn sf__btn-primary">Browse products</Link></div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {wishlist.map((p) => (
              <div key={p._id} className="text-center relative">
                <button type="button" className="absolute top-2 right-2 z-10 bg-white rounded-full p-2 shadow" onClick={() => toggleWish(p)} aria-label="Remove"><IconTrash width={14} height={14} /></button>
                <Link to={`/products/${p.slug}`}><Image src={p.image} alt={p.title} ratio={1} /></Link>
                <h3 className="font-medium mt-3"><Link to={`/products/${p.slug}`}>{p.title}</Link></h3>
                <Price price={p.price} compareAtPrice={p.compareAtPrice} className="justify-center" />
                <Link to={`/products/${p.slug}`} className="sf__btn sf__btn-secondary sf__btn-small mt-3 inline-block">View product</Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
